import { css } from '@emotion/react';
import type { StackConfigComponent } from 'common/stack/StackConfigDocuments';
import { ListItemText } from 'client/components/Other/ListItemText';
import { Tag } from 'client/components/Tag';
import { ComponentIcon } from 'client/sections/components/ComponentIcon';

export const StackPreviewComponent = ({ components }: { components: StackConfigComponent[] }) => {
  return (
    <ul css={listStyle}>
      {components.map((component) => (
        <Tag key={`${component.identifier}`} component="li" css={tagStyle}>
          <ComponentIcon size={24} url={component.package} type="component" hideType />
          <ListItemText primary={component.name} secondary={component.identifier} />
        </Tag>
      ))}
    </ul>
  );
};

const listStyle = css`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  padding: 0%;
  list-style: none;
`;

const tagStyle = css`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 12px 4px 10px;

  .body1 {
    margin-bottom: -4px;
  }
`;
